import { render } from "./ForgetPasswordComponent.vue?vue&type=template&id=d494269c&scoped=true&ts=true"
import script from "./ForgetPasswordComponent.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordComponent.vue?vue&type=script&lang=ts"

import "./ForgetPasswordComponent.vue?vue&type=style&index=0&id=d494269c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d494269c"]])

export default __exports__